var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5L21 21.5M21 15.5L15 21.5M10 21.5V15.1627C10 14.9182 10 14.7959 9.97237 14.6808C9.94787 14.5787 9.90747 14.4812 9.85264 14.3917C9.7908 14.2908 9.70432 14.2043 9.53137 14.0314L3.46863 7.96863C3.29568 7.79568 3.2092 7.7092 3.14736 7.60828C3.09253 7.51881 3.05213 7.42127 3.02763 7.31923C3 7.20414 3 7.08185 3 6.83726V5.1C3 4.53995 3 4.25992 3.10899 4.04601C3.20487 3.85785 3.35785 3.70487 3.54601 3.60899C3.75992 3.5 4.03995 3.5 4.6 3.5H19.4C19.9601 3.5 20.2401 3.5 20.454 3.60899C20.6422 3.70487 20.7951 3.85785 20.891 4.04601C21 4.25992 21 4.53995 21 5.1V6.83726C21 7.08185 21 7.20414 20.9724 7.31923C20.9479 7.42127 20.9075 7.51881 20.8526 7.60828C20.7908 7.7092 20.7043 7.79568 20.5314 7.96863L17 11.5",
    stroke: "#009A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0117,
    y: 14.0352,
    width: 10.5131,
    height: 2.17619,
    rx: 1.08809,
    transform: "rotate(44.5792 15.0117 14.0352)",
    fill: "#C11313"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5131,
    height: 2.17619,
    rx: 1.08809,
    transform: "matrix(-0.712281 0.701894 0.701894 0.712281 20.9727 14.0352)",
    fill: "#C11313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilterIcon);
export default __webpack_public_path__ + "static/media/reset_filter_icon.69dcd7d7ef9a7d68d9896c458f2ab500.svg";
export { ForwardRef as ReactComponent };